export default __webpack_public_path__ + "static/pse-b9f5a2ab7cef81f3412dd4cdf2cc8739.svg";